import React, { Component } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { emailCheck, required, number, fieldLength4 } from "../../../utils/formValidators";
import { loanNumberToolTip, emailToolTip } from "../../../utils/toolTips";
import { renderField } from "../../../utils/renderField";

export class LoanInfoFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSSN: true,
    };
    this.submitForm = this.submitForm.bind(this);
    this.toggleSSNVisibility = this.toggleSSNVisibility.bind(this);
    this.ssnField = React.createRef();
  }

  toggleSSNVisibility() {
    this.setState({ showSSN: !this.state.showSSN });
    this.ssnField.getRenderedComponent().setFocusToInput();
  }

  submitForm(values) {
    if (!values.dateOfBirth && !values.socialSecurityNumber) {
      throw new SubmissionError({
        dateOfBirth: "Please enter your SSN or Date of Birth",
        socialSecurityNumber: "Please enter your SSN or Date of Birth",
      });
    } else {
      this.props.submitForm(this.props.form);
    }
  }

  render() {
    const { pristine, submitting, handleSubmit, errors } = this.props;

    return (
      <form onSubmit={handleSubmit(this.submitForm)}>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Field
                component={renderField}
                label="Loan Account Number"
                id="loanNumber"
                name="loanNumber"
                tooltip={loanNumberToolTip}
                validate={[number, required]}
                inputMode="decimal"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Field
                id="ssn"
                component={renderField}
                label="Primary Borrower’s SSN/EIN (Last 4)"
                name="socialSecurityNumber"
                validate={[number, fieldLength4, required]}
                type={this.state.showSSN ? "text" : "password"}
                hasOtherIcon={true}
                withRef={true}
                inputMode="decimal"
                showHideOnClick={this.toggleSSNVisibility}
                showHideIcon={this.state.showSSN}
                ref={(node) => {
                  this.ssnField = node;
                }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Field
                label="Email Address"
                id="email"
                name="email"
                tooltip={emailToolTip}
                component={renderField}
                validate={[emailCheck, required]}
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <button disabled={submitting} className="button primary full" type="submit">
                Make a Payment
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

//Connect to Redux store
const LoanInfoForm = reduxForm({ form: "LoanInfo" })(LoanInfoFormComponent);

export default LoanInfoForm;



// WEBPACK FOOTER //
// ./src/components/forms/loan-info/loan-info-form.component.js